import React, { useEffect, useState } from "react";
import { SalonButtons } from "./SalonButtons"; // Componente para los botones de selección de salones.
import { CalendarioFull } from "./CalendarioFull"; // Componente que muestra el calendario completo.
import { hotelesOpciones } from "../../../hook/Arreglos";
import { ListaEventoTemporal } from "./ListaEventoTemporal";
import { useSelector } from "react-redux";
import { BotonCrearEvento } from "./BotonCrearEvento";

/**
 * Componente principal del calendario de hoteles.
 * Permite la selección de un hotel y actualiza dinámicamente los salones y el calendario.
 */
export const Calendario = ({ types = "mostrar" }) => {
    // Estado para el color del encabezado del calendario.
    const [colorHeader, setColorHeader] = useState("#dc3545");

    const { hotel } = useSelector((state) => state.evento);

    // Estado para almacenar el salón actualmente seleccionado.
    const [Salones, setSalones] = useState(1);

    /**
     * Maneja el cambio de hotel y actualiza los salones y el color del encabezado del calendario.
     *
     * @param {number} valor - ID del hotel seleccionado.
     */
    const handleSwitchHotel = (valor) => {
        // Encuentra el hotel correspondiente en la lista de opciones.
        const hotel = hotelesOpciones.find((opcion) => opcion.value === valor.toString());

        if (hotel) {
            // Actualiza el salón seleccionado y el color del encabezado.
            setSalones(valor);
            setColorHeader(hotel.backgroundColor);
        }
    };

    useEffect(() => {
        const hotelvalue = hotelesOpciones.find((opcion) => opcion.value === hotel.toString());
        setColorHeader(hotelvalue.backgroundColor);
    }, [hotel]);

    return (
        <div>
            <h2>Calendario de Hoteles</h2>
            <hr />
            {/* Componente de botones para cambiar entre los hoteles */}
            <SalonButtons switchHotel={handleSwitchHotel} type={types} />
            <hr />
            <ListaEventoTemporal type={types} />

            <CalendarioFull colorHeader={colorHeader} Salones={Salones} />
        </div>
    );
};
